import { ErrorTypes } from '../../field-error/error-types';
export const getRatingInputFieldError = (validation, error) => {
  var _validation$string, _validation$string2;
  const isMinMaxLengthError = (error == null ? void 0 : error.errorType) === ErrorTypes.MIN_LENGTH_ERROR || (error == null ? void 0 : error.errorType) === ErrorTypes.MAX_LENGTH_ERROR;
  if (!error || !isMinMaxLengthError) {
    return error;
  }
  const minLength = validation == null || (_validation$string = validation.string) == null ? void 0 : _validation$string.minLength;
  const maxLength = validation == null || (_validation$string2 = validation.string) == null ? void 0 : _validation$string2.maxLength;
  const isMinMaxValues = minLength && maxLength;
  if (isMinMaxValues && minLength === maxLength) {
    return {
      ...error,
      errorType: ErrorTypes.EXACT_CHARACTER_LENGTH_ERROR,
      errorMessage: `must have exactly ${minLength} characters`
    };
  }
  if (isMinMaxValues && minLength !== maxLength) {
    return {
      ...error,
      errorType: ErrorTypes.CHARACTER_LENGTH_RANGE_ERROR,
      errorMessage: `must have between ${minLength} and ${maxLength} characters`,
      params: {
        minLimit: minLength,
        maxLimit: maxLength
      }
    };
  }
  return error;
};
//# sourceMappingURL=rating-input-field-utils.js.map